import React from "react";
import { motion } from "framer-motion";

/**
 * Chapter — numbered manifesto-style section heading.
 * Renders e.g. "01 / The Problem"  ›  Big display heading  ›  optional body.
 */
export default function Chapter({
  number,
  eyebrow,
  title,
  subtitle,
  align = "left",
  accent = "cyan",
  className = "",
}) {
  const isCenter = align === "center";
  const eyebrowColor =
    accent === "lime" ? "text-[#A3FF5E]" : "text-[#00E5FF]";

  return (
    <div className={`${isCenter ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.5 }}
        className={`flex items-center gap-4 ${isCenter ? "justify-center" : ""}`}
      >
        <span className={`font-display text-xs sm:text-sm font-semibold ${eyebrowColor} tabular-nums`}>
          {number}
        </span>
        <span className="h-px w-10 bg-slate-700" />
        <span className={`text-[10px] tracking-[0.24em] uppercase font-bold ${eyebrowColor}`}>
          {eyebrow}
        </span>
      </motion.div>
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.55, delay: 0.06 }}
        className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white leading-[1.08]"
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.12 }}
          className="mt-5 text-base sm:text-lg text-slate-400 leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}
